import React, { ReactNode } from 'react';

import { Button } from '@mui/material';
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';

import classes from './ImagePreviewCard.module.scss';
import { LbChip } from '../../../ui-components';

type ImagePreviewCardProps = {
  onClear: () => void;
  children: ReactNode;
};

const ImagePreviewCard = ({ onClear, children }: ImagePreviewCardProps) => {
  return (
    <div className={classes.previewBox}>
      <LbChip label="Preview" size="small" color="info" className={classes.chip} />
      <Button
        variant="text"
        size="small"
        startIcon={<DeleteOutlineRoundedIcon />}
        className={classes.clearButton}
        onClick={onClear}
      >
        Clear
      </Button>
      {children}
    </div>
  );
};

export { ImagePreviewCard };
